import {
  type PriceInputs,
  type PricePresentation,
  hasValidSuggestedRetailPrice,
  statusQuoPricePresentation,
} from '../pricePresentation';

/**
 *
 *
 *
 *
 *
 */
export type OnexE3823Variant = 'E3823A' | 'E3823B' | 'E3823C' | 'E3823D' | 'E3823E';

const VARIANTS: readonly OnexE3823Variant[] = ['E3823A', 'E3823B', 'E3823C', 'E3823D', 'E3823E'];

export function parseE3823Variant(raw?: string): OnexE3823Variant {
  return (VARIANTS as readonly string[]).includes(raw ?? '') ? (raw as OnexE3823Variant) : 'E3823A';
}

export function e3823PricePresentation(args: PriceInputs & { variant?: string }): PricePresentation {
  const variant = parseE3823Variant(args.variant);

  if (variant === 'E3823A' || !hasValidSuggestedRetailPrice(args)) {
    return statusQuoPricePresentation(args);
  }

  return {
    showUvp: true,
    strikethrough: variant === 'E3823C' || variant === 'E3823E',
    redRetailPrice: variant === 'E3823D' || variant === 'E3823E',
  };
}
